<template>
  <span
    v-tooltip="ttOptions"
    class="tooltip-icon"
    :class="absolutePositioned ? 'absolute' : ''"
    :style="absolutePositioned ? absolutePosition : ''"
  >
    {{ iconPosition === 'after' ? text : '' }}
    <i
      :class="faIcon"
    />
    {{ iconPosition === 'before' ? text : '' }}
  </span>
</template>
<script>
import Vue from 'vue';
import VTooltip from 'v-tooltip';
Vue.use(VTooltip);

export default {
  name: 'Tooltip',
  props: {
    content: {
      type: String,
      default: '',
    },
    tooltipOptions: {
      type: Object,
      default () {
        return {}; //https://github.com/Akryum/v-tooltip#usage
      },
    },
    faIcon: {
      type: String,
      default: 'fad fa-question-square',
    },
    text: {
      type: String,
      default: '',
    },
    iconPosition: {
      type: String,
      default: 'after',
    },
    absolutePositioned: {
      type: Boolean,
      default: false,
    },
    absolutePosition: {
      type: String,
      default: 'top: 0; left: 0',
    },
  },
  data () {
    return {
      ttOptions: {},
    };
  },
  created () {
    this.ttOptions = { ...this.tooltipOptions };
    if (this.content !== '') {
      this.ttOptions.content = this.content;
    }
  },
};
</script>
<style lang="scss">
.tooltip-icon {
  cursor: pointer;
  color: $ben-franklin-blue-dark;
  &:hover {
    color: $ben-franklin-blue;
  }
  &.absolute {
    position: absolute;
  }
}
.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: $ben-franklin-blue-dark;
    color: white;
    padding: 1rem;
    border-radius: 4px;
    max-width: 500px;
    box-shadow: 0 5px 30px rgba(black, .1);
    //Temporary bulma fix
    strong {
      color: #fff !important;
    }
  }

  &.small {
    .tooltip-inner {
      max-width: 320px;
    }
  }
  &.medium {
    .tooltip-inner {
      max-width: 500px;
    }
  }
  &.large {
    .tooltip-inner {
      max-width: 800px;
    }
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: $ben-franklin-blue-dark;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
</style>